import axios from "../../Shared/auth-header";
import { toast } from "react-toastify";

export default {
  /**
   * Gets all column categories with their columns and user's selected columns
   * @param {number} memberId - The current user's member ID
   * @param {Array} selectedColumns - Optional array of currently selected columns
   * @returns {Object} Object with AvailableFields and SelectedFields
   */
  GetColumnCategories: async (memberId, selectedColumns = []) => {
    let url = `/api/FacilityColumns/GetColumnCategories?memberId=${memberId}`;
    try {
      var { data } = await axios.post(url, selectedColumns);
      return data;
    } catch (error) {
      toast.error("Error fetching column categories");
      return {
        availableFields: [],
        selectedFields: [],
      };
    }
  },

  /**
   * Gets the default columns for facility listing
   * @returns {Object} Response with default columns
   */
  GetDefaultColumns: async () => {
    let url = `/api/FacilityColumns/GetDefaultColumns`;
    try {
      var { data } = await axios.get(url);
      if (data && data.status === "success") {
        return data.data;
      } else {
        toast.error(data.message || "Error fetching default columns");
        return [];
      }
    } catch (error) {
      toast.error("Error fetching default columns");
      return [];
    }
  },

  /**
   * Saves the user's column preferences
   * @param {number} memberId - The member ID
   * @param {Array} columnIds - Array of selected column IDs
   * @param {Array} columnOrders - Array of column orders
   * @returns {Object} Response with status and message
   */
  SaveColumnPreferences: async (memberId, columnIds, columnOrders) => {
    let url = `/api/FacilityColumns/SaveColumnPreferences`;
    try {
      var { data } = await axios.post(url, {
        MemberId: memberId,
        ColumnIds: columnIds,
        ColumnOrders: columnOrders,
      });
      if (data && data.status === "success") {
        toast.success(data.message);
        return true;
      } else {
        toast.error(data.message || "Error saving column preferences");
        return false;
      }
    } catch (error) {
      toast.error("Error saving column preferences");
      return false;
    }
  },

  /**
   * Gets the user's saved column preferences
   * @param {number} memberId - The member ID
   * @returns {Object} Response with user's columns
   */
  GetUserColumnPreferences: async (memberId) => {
    let url = `/api/FacilityColumns/GetUserColumnPreferences?memberId=${memberId}`;
    try {
      var { data } = await axios.get(url);
      if (data && data.status === "success") {
        return {
          hasPreferences: data.hasPreferences,
          columns: data.data,
        };
      } else {
        return {
          hasPreferences: false,
          columns: [],
        };
      }
    } catch (error) {
      toast.error("Error fetching user column preferences");
      return {
        hasPreferences: false,
        columns: [],
      };
    }
  },

  /**
   * Resets the user's column preferences to defaults
   * @param {number} memberId - The member ID
   * @returns {boolean} Success status
   */
  ResetColumnPreferences: async (memberId) => {
    let url = `/api/FacilityColumns/ResetColumnPreferences?memberId=${memberId}`;
    try {
      var { data } = await axios.delete(url);
      if (data && data.status === "success") {
        toast.success(data.message);
        return true;
      } else {
        toast.error(data.message || "Error resetting column preferences");
        return false;
      }
    } catch (error) {
      toast.error("Error resetting column preferences");
      return false;
    }
  },
};
